import { createManagementApiKeyRequestSchema, createManagementApiKeyResponseSchema, listManagementApiKeysQuerySchema, managementApiKeyListSchema, revokeManagementApiKeyResponseSchema, } from '../contracts/management-api-keys';
import { organizationIdSchema, } from '../contracts/organizations';
import { parseSchema } from '../errors';
/**
 * List the organization's management API keys, newest first. Revoked keys are
 * hidden unless `includeRevoked` is set.
 */
export async function listManagementApiKeys(client, organizationId, params = {}) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedParams = parseSchema(listManagementApiKeysQuerySchema, params);
    const data = await client.get(`/organizations/${validatedId}/management-api-keys`, { params: validatedParams });
    return parseSchema(managementApiKeyListSchema, data);
}
/**
 * Mint a management API key. The plaintext access key comes back on this
 * response only — it is never retrievable again, so the caller must surface it
 * immediately.
 */
export async function createManagementApiKey(client, organizationId, body) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedBody = parseSchema(createManagementApiKeyRequestSchema, body);
    const data = await client.post(`/organizations/${validatedId}/management-api-keys`, validatedBody);
    return parseSchema(createManagementApiKeyResponseSchema, data);
}
/**
 * Revoke a management API key: deactivated locally and in Descope, with an
 * explicit `REVOKED` audit entry.
 */
export async function revokeManagementApiKey(client, organizationId, keyId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const data = await client.post(`/organizations/${validatedId}/management-api-keys/${keyId}/revoke`);
    return parseSchema(revokeManagementApiKeyResponseSchema, data);
}
//# sourceMappingURL=management-api-keys.js.map